const SET_ESS_KW = 'SET_ESS_KW';
const SET_ESS_KWH = 'SET_ESS_KWH';
const SET_ESS_PRICE = 'SET_ESS_PRICE';
const SET_MADE_IN_CA = 'SET_MADE_IN_CA';
const SET_INCLUDE_ESS = 'SET_INCLUDE_ESS';
const SET_BATTERY_TYPE = 'SET_BATTERY_TYPE';
const SET_ESS = 'SET_ESS';

export {
    SET_ESS_KW,
    SET_ESS_KWH,
    SET_ESS_PRICE,
    SET_MADE_IN_CA,
    SET_INCLUDE_ESS,
    SET_BATTERY_TYPE,
    SET_ESS,
};



// WEBPACK FOOTER //
// ./src/containers/common/ess/constants.js